// extracted by mini-css-extract-plugin
export default {"menuBlock":"CE-z","title":"DE-z","nav":"EE-z","flexCell":"FE-z","facetLink":"GE-z"};